import React from 'react';
import { Box, Checkbox, FormLabel, HStack, Stack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function AutoApprovalEmailInputs({ userEmail, register, defaultSelected }) {
  return (
    <Box justifyContent="space-around" mt={1}>
      <FormLabel color="greyScale.800" fontSize="sm" m={0}>Recipient(s): </FormLabel>
      <HStack fontSize="sm" justifyContent="center" pt={4}>
        <Stack spacing={2} w="40%">
          <Checkbox
            colorScheme="twitter"
            name="autoEmailInsured"
            {...register('autoEmailInsured')}
          >
            Insured
          </Checkbox>
          <Checkbox
            colorScheme="twitter"
            name="autoEmailCCParties"
            {...register('autoEmailCCParties')}
          >
            All cc&apos;d parties in insured&apos;s profile
          </Checkbox>
          <Checkbox
            name="autoEmailInsuredAgent"
            {...register('autoEmailInsuredAgent')}
            colorScheme="twitter"
          >
            Insured&apos;s Agent/Broker
          </Checkbox>
        </Stack>
        <Stack spacing={2} w="40%">
          <Checkbox
            name="autoEmailSelf"
            {...register('autoEmailSelf')}
            colorScheme="twitter"
          >
            Myself
            {' '}
            {`(${userEmail || ''})`}
          </Checkbox>
          <Checkbox
            name="autoEmailJobOwner"
            {...register('autoEmailJobOwner')}
            colorScheme="twitter"
          >
            Project Owner
          </Checkbox>
        </Stack>
      </HStack>
    </Box>
  );
}

AutoApprovalEmailInputs.propTypes = {
  userEmail: PropTypes.string,
  register: PropTypes.func,
  defaultSelected: PropTypes.string
};

export default AutoApprovalEmailInputs;
